export function constructUrl(_ref) {
  var videoId = _ref.videoId,
    controls = _ref.controls,
    mute = _ref.mute,
    loop = _ref.loop,
    autoplay = _ref.autoplay;
  var baseUrl = 'https://www.youtube.com/embed/';
  var params = new URLSearchParams({
    mute: mute ? '1' : '0',
    loop: loop ? '1' : '0',
    autoplay: autoplay ? '1' : '0',
    controls: controls ? '1' : '0',
    disablekb: '1'
  });
  if (loop) {
    params.append('playlist', videoId);
  }
  return "".concat(baseUrl).concat(videoId, "?").concat(params.toString());
}